<ng-container [ngSwitch]="mode">
   <fc-article-list *ngSwitchCase="'article-list'"></fc-article-list>
   <fc-article *ngSwitchCase="'article'"></fc-article>
   <fc-comparison *ngSwitchCase="'group'"></fc-comparison>
   <fc-article-list *ngSwitchCase="'topic'"></fc-article-list>
   <fc-comparison *ngSwitchCase="'category'"></fc-comparison>
   <fc-content-category *ngSwitchCase="'content-category'"></fc-content-category>
   <div *ngSwitchDefault>Invalid mode: {{ mode }}</div>
 </ng-container>